import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BCMContext = createContext({
  bcm: null,
  loading: true,
  reload: () => {},
  isWidgetEnabled: () => true,
  isGroupEnabled: () => true,
});

export function BCMProvider({ children }) {
  const [bcm, setBcm] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/brand-content");
      setBcm(data || {});
    } catch { setBcm({}); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  // Default = visible. If a key exists in bcm.dashboard_widgets and is false → hidden.
  const isWidgetEnabled = useCallback((key) => {
    if (!bcm || !bcm.dashboard_widgets) return true;
    return bcm.dashboard_widgets[key] !== false;
  }, [bcm]);

  const isGroupEnabled = useCallback((key) => {
    if (!bcm || !bcm.sidebar_groups) return true;
    return bcm.sidebar_groups[key] !== false;
  }, [bcm]);

  return (
    <BCMContext.Provider value={{ bcm, loading, reload, isWidgetEnabled, isGroupEnabled }}>
      {children}
    </BCMContext.Provider>
  );
}

export function useBCM() { return useContext(BCMContext); }
